module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Cap-3-643547a38582068ff619e0f169aa8fd995f94724c50425b4039bcce5c3fbdd6d.svg";